import { useQuery } from 'react-query';

import { getDataToCreateEnc } from 'api/encounters/getDataToCreateEnc';

export const useGetDataToCreateEnc = (objectSlug: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['getDataToCreateEnc', objectSlug],
    queryFn: () => getDataToCreateEnc(objectSlug),
    enabled: options?.enabled !== false && !!objectSlug,
  });
};
